import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=4ab88047&scoped=true&"
import script from "./Terms.vue?vue&type=script&lang=ts&"
export * from "./Terms.vue?vue&type=script&lang=ts&"
import style0 from "./Terms.vue?vue&type=style&index=0&id=4ab88047&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab88047",
  null
  
)

export default component.exports